/**
 * Testi italiani della pagina «Consumo» (ADR 0063): crediti, piano usato, dettaglio dei
 * token per categoria, periodo e modello, tabella crediti e token.
 */

/** Testi del consumo. */
export const consumption = {
  /** Voce di menu. */
  nav: 'Consumo',
  /** Titolo della pagina. */
  title: 'Consumo',
  /** Sottotitolo. */
  subtitle: 'Crediti usati dai tuoi set con la credenziale di institor.',
  /** Lettura non riuscita. */
  loadFailed: 'Lettura del consumo non riuscita. Riprova.',
  /** Schermata semplice. */
  summary: {
    /** Titolo della scheda. */
    title: 'Crediti del periodo',
    /** Etichetta del numero grande. */
    creditsUsed: 'Crediti usati',
    /** Inizio del periodo. */
    periodFrom: 'Dal {{date}}',
    /** Spiegazione del credito. */
    creditNote: 'Un credito vale 0,01 €, al prezzo standard dei modelli Claude.',
    /** Etichetta della barra. */
    planUsed: 'Piano usato',
    /** Valore della barra. */
    planPercent: '{{percent}}% del piano',
    /** Senza limiti. */
    unlimited: 'Senza limiti',
    /** Nota per chi non ha limiti. */
    unrestrictedNote: 'Il tuo account non ha limiti. I crediti mostrano solo quanto lavoro hanno fatto i set.',
    /** Titolo dell'importo oltre il piano. */
    overageTitle: 'Da pagare a parte',
    /** Importo oltre il piano. */
    overageValue: '{{credits}} crediti, {{amount}} IVA esclusa',
    /** Niente oltre il piano. */
    overageNone: 'Niente oltre il piano.',
    /** Consumo a fine mese acceso. */
    billingOn: 'Il consumo oltre il piano arriva in fattura con il rinnovo.',
    /** Consumo a fine mese spento. */
    billingOff: 'Oltre il piano il lavoro si ferma. Per continuare, accendi il consumo a fine mese.',
    /** Collegamento all'abbonamento. */
    billingLink: 'Vai all’abbonamento',
    /** Titolo del grafico. */
    chartTitle: 'Crediti degli ultimi 30 giorni',
    /** Riassunto del grafico per gli screen reader. */
    chartSummary: 'Crediti per giorno negli ultimi 30 giorni: {{total}} in tutto.',
    /** Pulsante del dettaglio. */
    detail: 'Dettaglio',
    /** Pulsante per chiudere il dettaglio. */
    hideDetail: 'Nascondi dettaglio',
  },
  /** Famiglie dei modelli. */
  families: {
    fable: 'Fable',
    opus: 'Opus',
    sonnet: 'Sonnet',
    haiku: 'Haiku',
    other: 'Altro',
  },
  /** Categorie del piano. */
  categories: {
    input: 'Input',
    output: 'Output',
    cache: 'Cache',
  },
  /** Spiegazione breve delle categorie. */
  categoryHelp: {
    input: 'Testo mandato al modello fuori dalla cache.',
    output: 'Testo scritto dal modello.',
    cache: 'Contesto scritto e riletto dalla cache. Costa molto meno dell’input.',
  },
  /** Dettaglio. */
  detail: {
    /** Titolo. */
    title: 'Dettaglio',
    /** Titolo della tabella dei limiti. */
    limitsTitle: 'Token del periodo e limiti del piano',
    /** Colonne. */
    category: 'Categoria',
    used: 'Usati',
    included: 'Inclusi nel piano',
    share: 'Uso',
    /** Limite assente. */
    noLimit: 'Senza limite',
    /** Titolo della tabella dei periodi. */
    usageTitle: 'Token per periodo e modello',
    /** Scelta della granularità. */
    granularityLabel: 'Raggruppa per',
    granularity: {
      day: 'Giorno',
      week: 'Settimana',
      month: 'Mese',
    },
    /** Colonne della tabella dei periodi. */
    period: 'Periodo',
    model: 'Modello',
    input: 'Input',
    output: 'Output',
    cacheWrite: 'Scrittura in cache',
    cacheRead: 'Lettura dalla cache',
    credits: 'Crediti',
    /** Etichetta della settimana. */
    weekOf: 'Settimana dal {{date}}',
    /** Nessun consumo. */
    empty: 'Nessun consumo in questi giorni.',
    /** Nota sull'inizio della misura. */
    measuredSince: 'La misura per giorno e per modello parte dal 2 novembre 2026.',
    /** Titolo della tabella oltre il piano. */
    overageTitle: 'Token oltre il piano',
    /** Nessun token oltre il piano. */
    overageEmpty: 'Nessun token oltre il piano in questo periodo.',
    /** Colonna dei token. */
    tokens: 'Token',
    /** Titolo della tabella di conversione. */
    conversionTitle: 'Crediti e token',
    /** Introduzione della tabella di conversione. */
    conversionIntro:
      'Un credito vale 0,01 €. I prezzi sono quelli standard delle API di Claude, con {{rate}} $ per 1 €.',
    /** Ricarico. */
    markupNote: 'Oltre il piano ogni credito costa il {{percent}}% in più.',
    /** Valore di una cella della conversione. */
    perCredit: '{{tokens}} token',
    /** Prezzo di una cella della conversione. */
    price: '{{price}} $ per milione',
    /** Prezzo nullo. */
    free: 'Gratis',
    /** Etichetta della tabella di conversione. */
    conversionLabel: 'Token che valgono un credito, per modello e tipo',
    /** Tipi della tabella di conversione. */
    kinds: {
      input: 'Input',
      output: 'Output',
      cache_write_5m: 'Scrittura in cache, 5 minuti',
      cache_write_1h: 'Scrittura in cache, 1 ora',
      cache_read: 'Lettura dalla cache',
    },
  },
};
